import Section from './Section';
import { BackgroundColorsType } from './Section.types';

export default Section;

export type { BackgroundColorsType };
